// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__mqD11","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__UIuOz"};